export default __webpack_public_path__ + "static/wind01-784653d9dea6c7e52f68988826e6331c.jpg";